
import { CONTANTS } from '~/constants';

export default {
  fetchOnServer: false,

  data() {
    this.ACCOUNT_CATEGORY = CONTANTS.ACCOUNT_CATEGORY;

    return {
      accounts: null,
    };
  },

  async fetch() {
    await this.fetchAccount();
  },

  computed: {
    totalCash() {
      return (this.accounts || []).reduce(
        (sum, { balance }) => sum + balance,
        0
      );
    },

    totalCashWithoutLending() {
      return this.totalCash - this.totalLending;
    },

    totalLending() {
      return 0;
      // return this.lendings.filter(item => item.category == 'card').reduce((prev, cur) => {
      //   return prev + cur.amount
      // }, 0) || 0
    },

    chartData() {
      const data = (this.accounts || []).map((item) => ({
        name: item.account_name,
        y: item.balance,
      }));
      return data;
    },

    chartAccounts() {
      const _this = this;
      const options = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          minPadding: 0,
          maxPadding: 0,
          height: this.$$isMobile ? 300 : 200,
          type: 'pie',
        },
        legend: {
          enabled: !this.$$isMobile,
          layout: 'vertical',
          align: this.$$isMobile ? 'center' : 'right',
          verticalAlign: 'middle',
          labelFormatter() {
            return `${this.name}: ${_this.$formatTextNumber(this.y)} VNĐ`;
          },
        },
        title: {
          text: null,
          style: {
            display: 'none',
          },
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: this.$$isMobile,
              formatter() {
                return `${this.point?.name}: ${_this.$formatTextNumber(
                  this.y
                )} VNĐ (${this.point?.percentage.toFixed(2)}%)`;
              },
            },
          },
        },
        series: [
          {
            name: 'Chiếm',
            colorByPoint: true,
            // innerSize: '50%',
            showInLegend: !this.$$isMobile,
            data: this.chartData,
          },
        ],
      };

      return options;
    },
  },

  methods: {
    choosePrimary(item) {
      return item && item.category == 'cash' && item.is_primary != true;
    },

    withdraw(fromAccount) {
      this.$vmodal.open({
        component: () => ({
          component: import('~/components/Modal/WithdrawTransaction.vue'),
          delay: 200,
          timeout: 3000,
        }),
        props: {
          accounts: this.accounts,
          fromAccount,
          close: this.fetchAccount,
        },
        wrapperProps: {
          clickCloseOutside: true,
          classes: 'pre-default-modal',
        },
      });
    },

    async fetchAccount() {
      const { data } = await this.$axios.request({
        url: '/api/person/account/',
        method: 'get',
      });

      this.accounts = data?.results;
    },
  },
};
